import React from "react";

const InstructionBlocks = ({ blocks = [] }) =>
  blocks.map((block, index) => {
    const key = `${block.type}-${index}`;

    switch (block.type) {
      case "ordered_list":
        return (
          <ol key={key}>
            {(block.items || []).map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ol>
        );
      case "unordered_list":
        return (
          <ul key={key}>
            {(block.items || []).map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        );
      case "note":
        return (
          <p key={key}>
            <strong>{block.text}</strong>
          </p>
        );
      default:
        return <p key={key}>{block.text}</p>;
    }
  });

export default InstructionBlocks;
